module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 38.d44613fa.png";